import { cloneDeep } from "lodash";

export function deepClone(thisObject) {
  return cloneDeep(thisObject);
}

export let constantData = {};

let responses = "";

export function getColumnIndex(csvDataArray, columnHeader) {
  if (csvDataArray) {
    return csvDataArray[0].indexOf(columnHeader);
  }
}

export function getColumnData(columnIndex, csvDataArray) {
  if (csvDataArray) {
    const responses = csvDataArray.map((respondent) => respondent[columnIndex]);
    responses.shift();
    return responses;
  }
}

export function setConstantData(dataFromCSV, columnHeaders) {
  const annualSalaryColumnIndex = getColumnIndex(
    dataFromCSV,
    columnHeaders.salaryHeader
  );
  const countryIndex = getColumnIndex(dataFromCSV, columnHeaders.countryHeader);
  const stateIndex = getColumnIndex(dataFromCSV, columnHeaders.stateHeader);
  const educationIndex = getColumnIndex(
    dataFromCSV,
    columnHeaders.educationHeader
  );
  const cityIndex = getColumnIndex(dataFromCSV, columnHeaders.cityHeader);
  const industryIndex = getColumnIndex(
    dataFromCSV,
    columnHeaders.industryHeader
  );
  const positionIndex = getColumnIndex(
    dataFromCSV,
    columnHeaders.positionHeader
  );
  const experienceIndex = getColumnIndex(
    dataFromCSV,
    columnHeaders.experienceHeader
  );
  const genderIndex = getColumnIndex(dataFromCSV, columnHeaders.genderHeader);

  constantData = {
    responses: {
      annualSalaryResponses: getColumnData(
        annualSalaryColumnIndex,
        dataFromCSV
      ),
      countryResponses: getColumnData(countryIndex, dataFromCSV),
      stateResponses: getColumnData(stateIndex, dataFromCSV),
      educationResponses: getColumnData(educationIndex, dataFromCSV),
      cityResponses: getColumnData(cityIndex, dataFromCSV),
      industryResponses: getColumnData(industryIndex, dataFromCSV),
      positionResponses: getColumnData(positionIndex, dataFromCSV),
      experienceResponses: getColumnData(experienceIndex, dataFromCSV),
      genderResponses: getColumnData(genderIndex, dataFromCSV),
    },
    filterIndexes: {
      annualSalaryColumnIndex: annualSalaryColumnIndex,
      countryIndex: countryIndex,
      stateIndex: stateIndex,
      educationIndex: educationIndex,
      cityIndex: cityIndex,
      industryIndex: industryIndex,
      positionIndex: positionIndex,
      experienceIndex: experienceIndex,
      genderIndex: genderIndex,
    },
  };
}

export function countOccurrences(array, rangeIndex) {
  let occurrences = 0;
  array.forEach((element) => {
    if (rangeIndex < 8) {
      if (
        element > 0 + rangeIndex * 25000 &&
        element <= 25000 + rangeIndex * 25000
      ) {
        occurrences += 1;
      }
    } else if (element > 200000) {
      occurrences += 1;
    }
  });
  return occurrences;
}

export function filterResponses({
  filtersArray,
  responsesToFilter,
  formDataObject,
}) {
  let filterResponsesRowsArray = [];
  let resultType = "individual";
  // pushes array of rows with filtered values
  if (filtersArray.length) {
    filtersArray.forEach((filter) => {
      filterResponsesRowsArray.push(
        constantData.responses[`${filter}Responses`].reduce(
          (rowsArray, current, csvRow) => {
            current.toLowerCase() === formDataObject[filter].toLowerCase() &&
              rowsArray.push(csvRow);
            return rowsArray;
          },
          []
        )
      );
    });

    // gets intersection of all of the filtering rows
    filterResponsesRowsArray = filterResponsesRowsArray.reduce((a, b) =>
      b.filter(Set.prototype.has, new Set(a))
    );

    if(filterResponsesRowsArray.length == 0){
      resultType = "global";
      for (let i = 1; i <= constantData.responses["annualSalaryResponses"].length; i++) {
        filterResponsesRowsArray.push(i);
      }
    }

    // filters all the salary responses based on CSV rows chosen above
    let filteredResponses = responsesToFilter.filter((response, index) => {
      if (filterResponsesRowsArray.includes(index)) {
        if(response) {
          return response;
        }
      }
      return null;
    });

    if(filteredResponses.length == 0) {
      resultType = "global";
      for (let i = 1; i <= constantData.responses["annualSalaryResponses"].length; i++) {
        filterResponsesRowsArray.push(i);
      }
      filteredResponses = responsesToFilter.filter((response, index) => {
        if (filterResponsesRowsArray.includes(index)) {
          if(response) {
            return response;
          }
        }
        return null;
      });
    }

    return {
      filteredResponses: filteredResponses,
      resultType: resultType
    };
  }

  return {
    filteredResponses: responsesToFilter,
    resultType: resultType
  };
}

export function setHistogramData(salaryRanges, salaryResponses) {
  const histogramData = [];

  salaryRanges.forEach((_, index) => {
    histogramData.push(countOccurrences(salaryResponses, index));
  });
  const percentHistogramData = histogramData.map(
    (d) => (d / salaryResponses.length) * 100
  );
  return percentHistogramData;
}

export function setResultsData({ props, filtersArray, formData }) {
  const { salaryRanges, updateResultsData } = props;
  let typeOfResult;

  let annualSalaryResponses = constantData.responses.annualSalaryResponses;
  let filteredAnnualSalaryResponses = [];
  if (filtersArray) {
    // Removes empty strings (no response / other) from answers array and filters remaining strings using array of specified filters
    const filteredAnnualSalaryResponsesData = filterResponses({
      filtersArray: filtersArray,
      responsesToFilter: annualSalaryResponses,
      formDataObject: formData,
    });
    const { filteredResponses, resultType } = filteredAnnualSalaryResponsesData;
    filteredAnnualSalaryResponses = filteredResponses.filter(Boolean);

    typeOfResult = resultType;
    
    filteredAnnualSalaryResponses = filteredAnnualSalaryResponses.filter(
      function (value) {
        return Number(value) > 0;
      }
    );
  }


  
  // Removes empty strings (no response) from answers array
  annualSalaryResponses = annualSalaryResponses.filter(Boolean);
  annualSalaryResponses = annualSalaryResponses.filter(function (value) {
    return Number(value) > 0;
  });

  const histogramData = filteredAnnualSalaryResponses.length
    ? setHistogramData(salaryRanges, filteredAnnualSalaryResponses)
    : setHistogramData(salaryRanges, annualSalaryResponses);
  responses = filtersArray
    ? filteredAnnualSalaryResponses
    : annualSalaryResponses;

  updateResultsData(
    histogramData,
    salaryRanges,
    formData.userResponseIndex,
    formData,
    responses,
    typeOfResult
  );

  return {
    histogramData,
    salaryRanges,
    userResponseIndex: formData.userResponseIndex,
    formData,
    responses,
    typeOfResult
  };
}

function capitalizeStringsInArray(arrayOfStrings) {
  const uppercased = arrayOfStrings.map((string) => {
    const regexp = /^[A-Z]/;
    if (!regexp.test(string)) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
      return string;
    }
  });
  return uppercased;
}

export function getSelectOptions(whichResponses, filterIndexesArrays) {
  let options = constantData.responses[whichResponses];

  if (filterIndexesArrays && filterIndexesArrays[1].length) {
    options = filterIndexesArrays[1].map((index) => options[index]);
  } else if (filterIndexesArrays) {
    options = filterIndexesArrays[0].map((index) => options[index]);
  }

  options = capitalizeStringsInArray(options);
  options = [...new Set(options)].filter(Boolean);

  return options;
}

export function updateChartData(chart, labels, chartData, userResponseIndex, formData) {

  chart.data.labels = [];
  chart.data.datasets[0].data = [];
  chart.data.datasets[0].borderWidth = [0,0,0,0,0,0,0,0,0];
  labels.forEach((label) => {
    chart.data.labels.push(label);
  });
  chartData.forEach((datum) => {
    chart.data.datasets[0].data.push(datum);
  });
  chart.data.datasets[0].borderWidth[userResponseIndex] = 2;
  chart.update();
}

function compareNumbers(a, b) {
  return a - b;
}

export function getPercentile(percentile, array) {
  const arraySorted = array.sort(compareNumbers);
  const pWeight = (percentile / 100) * (arraySorted.length + 1);
  const index = Math.floor(pWeight) - 1;
  const fraction = pWeight % 1;
  const indexedNumber = index >= 0 ? Number(arraySorted[index]) : 0;
  const margin = Number(arraySorted[index + 1])
    ? Number(arraySorted[index + 1]) - Number(arraySorted[index])
    : Number(arraySorted[index]);

  const result = indexedNumber + fraction * margin;

  return result;
}

export function getAverage(array) {
  const cleanData = array.map(function (element) {
    return /^\d+$/.test(element) ? parseInt(element) : 0;
  });

  const sum = cleanData.length
    ? cleanData.reduce((sum, val) => (sum += val))
    : "";

  const len = array.length;

  const result = sum && len ? Math.round((sum / len) * 10) / 10 : "No data";

  return result;
}
